module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0003.4dede820.png";